import * as React from 'react';
import { Edit, SimpleForm, ReferenceInput, SelectInput, TextInput, Toolbar, SaveButton, required, useNotify, useRedirect } from 'react-admin';
import { Button } from '@mui/material';
import useAdmin from '../hooks/useAdmin';

const CustomToolbar = () => {
    const redirect = useRedirect();

    const handleBack = () => {
        redirect('/directorysubcategories');
    };

    return (
        <Toolbar>
            <SaveButton />
            <Button color="primary" onClick={handleBack} style={{ marginLeft: '10px' }}>Back</Button>
        </Toolbar>
    );
};

export const DirectorySubcategoryEdit = (props: any) => {
    const notify = useNotify();
    const redirect = useRedirect();

    const onSuccess = () => {
        notify('resources.directorysubcategories.notification.updated', {
            type: 'info',
            undoable: true,
            messageArgs: { smart_count: 1, name: 'Directory Subcategory' }
        });
        redirect('/directorysubcategories');
    };
    useAdmin();
    return (
        <Edit {...props} mutationOptions={{ onSuccess: onSuccess }}>
            <SimpleForm toolbar={<CustomToolbar />}>
                <ReferenceInput source="category_id" reference="directorycategories" label="Category">
                    <SelectInput optionText="category_name" validate={[required()]}/>
                </ReferenceInput>
                <TextInput source="subcategory_name" label="Subcategory Name"/>
                <TextInput source="subcategory_description" label="Description"/>
            </SimpleForm>
        </Edit>
     );
};

export default DirectorySubcategoryEdit;


